import { webEnums } from '@vectronic/openApi-customer';

export const extractEmails = (text: string) =>
  text.match(/(?<![a-z0-9._-])([a-z0-9._-]+@[a-z0-9._-]+\.[a-z0-9._-]+)/gi);

export const roleRanks: Record<webEnums.Role, number> = {
  READER: 1,
  DATA_MANAGER: 2,
  DEVICE_MANAGER: 3,
  OWNER: 4,
};

export const roleRank = (role: string | undefined): number => roleRanks[role as webEnums.Role] ?? 0;

export const isHigherThan = (role1: webEnums.Role, role2: webEnums.Role) =>
  roleRank(role1) > roleRank(role2);

export const isHigherOrEqualToReader = (role: webEnums.Role) => roleRank(role) >= roleRanks.READER;

export interface PartitionedRoleChange {
  updatableIds: number[];
  skippedHigherRoleIds: number[];
}

export interface PartitionedTargetRoleChange {
  downgradeIds: number[];
  upgradeIds: number[];
  unchangedIds: number[];
}

export const partitionIdsByTargetRole = (
  collarRoles: Record<number, webEnums.Role>,
  targetRole: webEnums.Role,
): PartitionedTargetRoleChange => {
  const downgradeIds: number[] = [];
  const upgradeIds: number[] = [];
  const unchangedIds: number[] = [];
  Object.entries(collarRoles ?? {}).forEach(([id, currentRole]) => {
    if (!currentRole) return;
    const currentRank = roleRank(currentRole);
    const targetRank = roleRank(targetRole);
    if (currentRank > targetRank) downgradeIds.push(Number(id));
    else if (currentRank < targetRank) upgradeIds.push(Number(id));
    else unchangedIds.push(Number(id));
  });
  return { downgradeIds, upgradeIds, unchangedIds };
};

export const partitionIdsForRoleChange = (
  collarRoles: Record<number, webEnums.Role>,
  memberIds: number[] | undefined,
  ownRole: webEnums.Role,
): PartitionedRoleChange => {
  const updatableIds: number[] = [];
  const skippedHigherRoleIds: number[] = [];
  (memberIds ?? []).forEach((id) => {
    const currentRole = collarRoles?.[id];
    if (!currentRole) return;
    if (roleRank(currentRole) > roleRank(ownRole)) skippedHigherRoleIds.push(id);
    else updatableIds.push(id);
  });
  return { updatableIds, skippedHigherRoleIds };
};
